/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 09/11/21
 */

import React, { useMemo } from 'react';
import { ArrayControlProps, ControlElement, createDefaultValue, JsonSchema } from '@jsonforms/core';
import { Grid, GridItem, Heading, IconButton, Td, Tooltip, Tr } from '@chakra-ui/react';
import Icons from '@/components/icons/Icons';
import { namedMemo } from '@/utils/namedMemo';

export interface ChakraTableToolbarProps
    extends Pick<ArrayControlProps, 'addItem' | 'label' | 'path' | 'schema' | 'enabled'> {
    numColumns: number;
    uischema: ControlElement;
    rootSchema: JsonSchema;
}

const ChakraTableToolbar = namedMemo(
    'ChakraTableToolbar',
    ({ numColumns, label, path, addItem, schema, enabled }: ChakraTableToolbarProps) => (
        <Tr>
            <Td colSpan={numColumns}>
                <Grid justifyContent={'flex-start'} alignItems={'center'} gridGap={2}>
                    <GridItem>
                        <Heading as="h3" size="md">
                            {label}
                        </Heading>
                    </GridItem>
                </Grid>
            </Td>
            {enabled && (
                <>
                    <Td textAlign="right">
                        <Tooltip id="tooltip-add" label={`Add to ${label}`} placement="bottom-end">
                            <IconButton
                                aria-label={`Add to ${label}`}
                                onClick={useMemo(() => addItem(path, createDefaultValue(schema)), [path, schema])}
                                icon={<Icons.AddIcon />}
                            />
                        </Tooltip>
                    </Td>
                </>
            )}
        </Tr>
    ),
);

export default ChakraTableToolbar;
